





























































import { Component, Prop, Mixins } from 'vue-property-decorator'

import { ItemOption, ItemOptionValue, ItemVariant } from '@/interfaces'
import { Common } from '@/mixins'

@Component
export default class extends Mixins(Common) {
  @Prop() readonly availableItemOptions!: ItemOptionValue[]
  @Prop() readonly options!: ItemOption[]
  @Prop() readonly itemPrice!: number
  @Prop() readonly itemId!: string
  @Prop() readonly addedItemVariants!: {
    name: string;
    variantId: string;
    quantity: number;
    additionalAmount: number;
  }[]

  selectors: {
    key: string;
    title: string;
    option?: ItemOption;
    optionValues: {
      name: string;
      selectable: boolean;
    }[];
    isEnable: boolean;
    selectedIndex: number;
  }[] = []

  initSelectors () {
    this.selectors = []
    this.options.forEach((option, index) => {
      if (index === 0) {
        const optionValues = this.getDropdownOptionValues(0)
        this.selectors.push({ key: option.id, title: `${option.name} 선택`, option, optionValues, isEnable: true, selectedIndex: -1 })
      } else {
        this.selectors.push({ key: option.id, title: `${option.name} 선택`, option, optionValues: [], isEnable: false, selectedIndex: -1 })
      }
    })

    if (this.options.length === 0) {
      const optionValues = this.getDropdownOptionValues(0)
      this.selectors.push({ key: '-1', title: '옵션 선택', optionValues, isEnable: true, selectedIndex: -1 })
    }
  }

  mounted () {
    this.initSelectors()
  }

  addItemVariant (variant: ItemVariant) {
    if (this.addedItemVariants.some(addedItemVariant => addedItemVariant.variantId === variant.id)) {
      return
    }

    const name = variant.optionValues.map(optionValue => optionValue.optionValue).join(' ') || '옵션 없음'
    this.$emit('add', { name, variantId: variant.id, additionalAmount: variant.additionalAmount, quantity: 1 })
    this.initSelectors()
  }

  selectorSelected (index: number, value: number) {
    this.selectors[index].selectedIndex = value

    if (value >= 0) {
      if (index + 1 < this.selectors.length) {
        // set available options for next selector
        this.$set(this.selectors[index + 1], 'optionValues', this.getDropdownOptionValues(index + 1))
        this.$set(this.selectors[index + 1], 'isEnable', true)
      } else {
        // add item variant
        const avaiableOptions = this.getAvailableOptions(0, index, this.availableItemOptions)
        if (!avaiableOptions) {
          return
        }

        const selectorOption = this.selectors[index].option
        if (!selectorOption) {
          if (avaiableOptions[0].variant) {
            this.addItemVariant(avaiableOptions[0].variant)
          }
          return
        }

        const option = avaiableOptions.find(availableOption => availableOption.optionValueId === selectorOption.values[value].id)
        if (!option || !option.variant) {
          return
        }

        this.addItemVariant(option.variant)
      }
    }
  }

  get addedItemVariantsTotalAmount () {
    return this.addedItemVariants.reduce((total, cur) => total + (cur.additionalAmount + this.itemPrice) * cur.quantity, 0)
  }

  getAvailableOptions (currentIndex: number, selectorIndex: number, currentAvailableOptions?: ItemOptionValue[]): ItemOptionValue[] | undefined {
    if (selectorIndex === 0) {
      return currentAvailableOptions
    }

    if (this.selectors[currentIndex].selectedIndex < 0) {
      return undefined
    }
    const currentSelectedOptionValueId = this.options[currentIndex].values[this.selectors[currentIndex].selectedIndex].id
    const currentAvailableOption = currentAvailableOptions ? currentAvailableOptions.find(option => option.optionValueId === currentSelectedOptionValueId) : undefined
    const nextAvailableOptions = currentAvailableOption ? currentAvailableOption.nextOptionValues : undefined

    if (currentIndex === selectorIndex - 1) {
      return nextAvailableOptions
    } else {
      return this.getAvailableOptions(currentIndex + 1, selectorIndex, nextAvailableOptions)
    }
  }

  getDropdownOptionValues (selectorIndex: number) {
    const avaiableOptions = this.getAvailableOptions(0, selectorIndex, this.availableItemOptions)
    const values: { name: string; selectable: boolean }[] = []
    if (this.options.length === 0) {
      values.push({ name: '옵션 없음', selectable: true })
    } else {
      values.push(...this.options[selectorIndex].values.map(optionValue => {
        const avaiableOption = avaiableOptions
          ? avaiableOptions.find(availableOption => availableOption.optionValueId === optionValue.id)
          : undefined
        if (avaiableOption) {
          const amount = avaiableOption.variant ? avaiableOption.variant.additionalAmount : 0
          if (amount !== 0) {
            return { name: `${optionValue.text}  (${amount > 0 ? '+' : ''}${this.formatNumber(amount)}원)`, selectable: true }
          } else {
            return { name: optionValue.text, selectable: true }
          }
        } else {
          return { name: optionValue.text + ' [품절]', selectable: false }
        }
      }))
    }

    return values
  }
}
